/**************************************************
 * Nombre:       Home_Mas_Vendidos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import TituloHuella from "./SubComponentes/TituloHuella";
import {useSeleccion} from "./SubComponentes/Hooks/useSeleccion";
import Lista_Productos from "./Lista_Productos";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../../Servicios/BD/obtenerCol";
import {where} from "firebase/firestore";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Home_Mas_Vendidos = () => {
    const {sCell} = useResponsive()
    const [tipos, setTipos] = useState([])
    const {Lista, seleccionado} = useSeleccion({lista: tipos})
    const [productos, setProductos] = useState([])

    useEffect(() => {

        if (seleccionado) {
            let w = [where('tipo', '==', seleccionado), where('masVendido', '==', true)]
            obtenerColWheres({col: 'productos', wheres: w}).then((dox) => {
                if (dox.res) {
                    setProductos(dox.data);
                }
            })
        }


    }, [seleccionado])


    useEffect(() => {
        obtenerCol('tipos').then(dox => {
            if (dox.res) {
                setTipos(dox.data.map((it) => it.nombre));
            }
        })
    }, [])
    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                    >

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                            <TituloHuella titulo={'Mas vendidos de la semana'}/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 6, md: 6}}
                              sx={{justifyContent: sCell ? 'center' : 'flex-end', mt: sCell ? 3 : 0}}>
                            <Lista/>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 10}}>
                            <Lista_Productos items={productos}/>
                        </Grid>


                    </Grid>
                </Grid>

            </Grid>

        </Grid>
    )

}
export default Home_Mas_Vendidos  